function getLinksFromProps(props) {
  const { link1Text, link1Url, link2Text, link2Url, link3Text, link3Url, link4Text, link4Url } = props;

  const links = [
    { text: link1Text, url: link1Url },
    { text: link2Text, url: link2Url },
    { text: link3Text, url: link3Url },
    { text: link4Text, url: link4Url },
  ];

  return links.filter((x) => x.text);
}

export default getLinksFromProps;



// WEBPACK FOOTER //
// ./src/js/widgets/Header/SiteLinks/getLinksFromProps.js